/** @format */

/**
 * Generic, presentation-only PDP info callout content. Sourced from a
 * text-story Content Fragment via the personalization service; Adobe Target
 * decides eligibility, so the component renders whatever content it receives.
 */
export type PersonalizedInfoCalloutContent = {
  title: string;
  subtitle?: string;
  textColor: string;
  backgroundColor: string;
  iconUrl?: string;
  ctaLabel?: string;
  ctaUrl?: string;
};
